import { CSSObject, Stack, styled, Typography } from '@mui/material';
import { Button } from '../../../components/Rumblefish23Theme/Button';

export const StyledStack = styled(Stack)(({ theme }) => ({
  borderRadius: '24px',
  alignItems: 'center',
  border: `1px solid ${theme.palette.greyBorder?.LIGHT + '35'}`,
}));
export const StyledTextWrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
}));
export const StyledImage = styled(`img`)(() => ({
  borderRadius: '24px',
  height: 'auto',
  width: '100%',
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  letterSpacing: '-0.02em',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_2} inset !important`,
  },
}));
